'use strict';

const { h } = require('preact');

const Value = ({
  classes,
  pricing: { formattedValue },
  showXForYStrikethrough,
  isXForYCloDeal,
}) => {
  // can this be removed?
  if (!formattedValue || (!showXForYStrikethrough && isXForYCloDeal)) {
    return null;
  }
  return h('div', { class: classes }, formattedValue);
};

module.exports = Value;
